const AMapCDN = 'https://webapi.amap.com/maps?v=1.3&key=73cddabc2173e0166a622f4483d3592a&plugin=AMap.DistrictSearch';
const AMapUiCDN = 'https://webapi.amap.com/ui/1.0/main.js';
const VueCDN = 'https://cdn.staticfile.org/vue/2.6.14/vue.min.js';
const AxiosCDN = 'https://cdn.staticfile.org/axios/0.26.1/axios.min.js';
const VueRouterCDN = 'https://cdn.staticfile.org/vue-router/3.5.3/vue-router.min.js';
const VuexCDN = 'https://cdn.staticfile.org/vuex/3.6.2/vuex.min.js';
const TinymceCDN = 'https://cdn.staticfile.org/tinymce/5.10.3/tinymce.min.js';
const html2canvasCDN = 'https://cdn.staticfile.org/html2canvas/1.4.1/html2canvas.min.js';
module.exports = {
  AMapCDN,
  AMapUiCDN,
  VueCDN,
  AxiosCDN,
  VueRouterCDN,
  VuexCDN,
  TinymceCDN,
  html2canvasCDN
};